/**
 * Tipos de validação e mensagens para Lead Time Breakdown
 */
export const VALIDATION_TYPES = {
  MISSING_ID: {
    type: 'missing_id',
    getMessage: (lineNumber) => `Linha ${lineNumber}: O campo 'ID' é obrigatório e não pode estar vazio.`
  },
  MISSING_TIPO: {
    type: 'missing_tipo',
    getMessage: (lineNumber, id) => `Linha ${lineNumber}: O campo 'Tipo de Item' é obrigatório e não pode estar vazio (ID: "${id || 'ID não informado'}").`
  },
  MISSING_CLOSED_DATE: {
    type: 'missing_closed_date',
    getMessage: (lineNumber, id) => `Linha ${lineNumber}: O campo 'Closed Date' é obrigatório e não pode estar vazio (ID: "${id || 'ID não informado'}").`
  },
  MISSING_WORKFLOW_DATE: {
    type: 'missing_workflow_date',
    getMessage: (lineNumber, column, id) => `Linha ${lineNumber}: O campo '${column}' é obrigatório no fluxo de trabalho e não pode estar vazio (ID: "${id || 'ID não informado'}").`
  },
  INVALID_CLOSED_DATE: {
    type: 'invalid_closed_date',
    getMessage: (lineNumber, date, id) => `Linha ${lineNumber}: 'Closed Date' "${date}" não é uma data válida (ID: "${id || 'ID não informado'}").`
  },
  INVALID_WORKFLOW_DATE: {
    type: 'invalid_workflow_date',
    getMessage: (lineNumber, column, date, id) => `Linha ${lineNumber}: Data inválida na coluna "${column}": "${date}" (ID: "${id || 'ID não informado'}").`
  },
  WORKFLOW_DATE_SEQUENCE_ERROR: {
    type: 'workflow_date_sequence_error',
    getMessage: (lineNumber, column1, date1, column2, date2, id) => `Linha ${lineNumber}: Data da etapa "${column1}" (${date1}) não pode ser posterior à etapa "${column2}" (${date2}) (ID: "${id || 'ID não informado'}").`
  },
  WORKFLOW_DATE_AFTER_CLOSED: {
    type: 'workflow_date_after_closed',
    getMessage: (lineNumber, column, workflowDate, closedDate, id) => `Linha ${lineNumber}: Data da etapa "${column}" (${workflowDate}) não pode ser posterior à "Closed Date" (${closedDate}) (ID: "${id || 'ID não informado'}").`
  }
};
